export function buildStudentQrPayload(studentId) {
  const id = String(studentId || '').trim();
  if (!id) return '';
  return `ABSENSI:${id}`;
}

export function parseStudentIdFromQr(text) {
  const raw = String(text || '').trim();
  if (!raw) return null;

  const prefixed = raw.match(/ABSENSI:([A-Za-z0-9_-]+)/i);
  if (prefixed) return prefixed[1];

  try {
    const url = new URL(raw);
    const fromQuery = url.searchParams.get('student_id') || url.searchParams.get('id');
    if (fromQuery) return String(fromQuery).trim();
  } catch (_) {
    // not a URL
  }

  if (/^[A-Za-z0-9_-]{2,20}$/.test(raw)) return raw;
  return null;
}

export function formatClassLabel(grade, classroom) {
  if (grade != null && classroom) return `Kelas ${grade}${classroom}`;
  if (grade != null) return `Kelas ${grade}`;
  if (classroom) return String(classroom);
  return '-';
}
